import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import MerchantPayouts from 'ui/organizms/MerchantPayouts';

const MerchantPayoutsScreen = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Finance | Merchant Payouts'
    >
        <MerchantPayouts />
    </Screen>
);

export default memo(MerchantPayoutsScreen);
